import { Inspector } from './Inspector';
export class InspectorConsole extends Inspector {
  constructor(args = {}) {
    super(Object.assign({}, args, {
      debug: true
    }));
    this.logPrefix = `[FSM:${this.name}]`;
  }
  add(entry) {
    const wasAdded = super.add(entry);
    if (wasAdded) {
      this.logEntry(entry);
    }
    return wasAdded;
  }
  logEntry(entry) {
    var _entry$data, _entry$data2, _entry$data3, _entry$data4, _entry$data5, _entry$data6;
    const timestamp = new Date().toISOString();
    switch (entry.type) {
      case 'fsm.transition.take':
        console.log(`${this.logPrefix} TRANSITION`, `${(_entry$data = entry.data) === null || _entry$data === void 0 ? void 0 : _entry$data.previousState} → ${(_entry$data2 = entry.data) === null || _entry$data2 === void 0 ? void 0 : _entry$data2.nextState}`, entry.event ? `(event: ${entry.event.type})` : '', {
          timestamp,
          entry
        });
        break;
      case 'fsm.action.resolve':
        console.log(`${this.logPrefix} ACTION`, ((_entry$data3 = entry.data) === null || _entry$data3 === void 0 ? void 0 : _entry$data3.action) || 'unknown', entry.event ? `(event: ${entry.event.type})` : '', {
          timestamp,
          entry
        });
        break;
      case 'fsm.action.error':
        console.error(`${this.logPrefix} ACTION ERROR`, ((_entry$data4 = entry.data) === null || _entry$data4 === void 0 ? void 0 : _entry$data4.action) || 'unknown', entry.event ? `(event: ${entry.event.type})` : '', {
          timestamp,
          entry,
          error: entry.error
        });
        break;
      case 'fsm.service.resolve':
        console.log(`${this.logPrefix} SERVICE RESOLVED`, ((_entry$data5 = entry.data) === null || _entry$data5 === void 0 ? void 0 : _entry$data5.state) || 'unknown', entry.event ? `(event: ${entry.event.type})` : '', {
          timestamp,
          entry
        });
        break;
      case 'fsm.service.error':
        console.error(`${this.logPrefix} SERVICE ERROR`, ((_entry$data6 = entry.data) === null || _entry$data6 === void 0 ? void 0 : _entry$data6.state) || 'unknown', entry.event ? `(event: ${entry.event.type})` : '', {
          timestamp,
          entry,
          error: entry.error
        });
        break;
      case 'fsm.guard.take':
        console.log(`${this.logPrefix} GUARD PASSED`, entry.description || 'unknown guard', entry.event ? `(event: ${entry.event.type})` : '', {
          timestamp,
          entry
        });
        break;
      case 'fsm.guard.skip':
        console.log(`${this.logPrefix} GUARD FAILED`, entry.description || 'unknown guard', entry.event ? `(event: ${entry.event.type})` : '', {
          timestamp,
          entry
        });
        break;
      case 'fsm.event.ignore':
        console.warn(`${this.logPrefix} EVENT IGNORED`, entry.event ? entry.event.type : 'unknown event', 'No transition defined for current state', {
          timestamp,
          entry
        });
        break;
      default:
        console.log(`${this.logPrefix} ${entry.type.toUpperCase()}`, entry.description || '', entry.event ? `(event: ${entry.event.type})` : '', {
          timestamp,
          entry
        });
    }
  }
  start() {
    super.start();
    console.log(`${this.logPrefix} Console logging started`);
  }
  stop() {
    super.stop();
    console.log(`${this.logPrefix} Console logging stopped`);
  }
}